var map = {
	"./assets/aboutus.jpg": "./src/assets/aboutus.jpg",
	"./assets/assets_t2b/aboutus.jpg": "./src/assets/assets_t2b/aboutus.jpg",
	"./assets/assets_vit/aboutus.jpg": "./src/assets/assets_vit/aboutus.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src sync recursive ^\\.\\/.*\\/aboutus\\.jpg$";